/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMessageHeart = createReactComponent("outline", "message-heart", "IconMessageHeart", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h3.5", "key": "svg-1" }], ["path", { "d": "M10.48 19.512l-2.48 1.488v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

export { IconMessageHeart as default };
//# sourceMappingURL=IconMessageHeart.mjs.map
